import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { useIsDarkMode } from "store/atoms";
import { ToggleStyles } from "./SettingsStyles";

// const ListItemCheckbox = ({ label, checked, onChange, className }) => (
//   <ListItem
//     button={true}
//     style={{ paddingBottom: 0, paddingTop: 0 }}
//     className="listItemCheckbox"
//   >
//     <FormControlLabel
//       control={
//         <Checkbox className={className} checked={checked} onChange={onChange} />
//       }
//       label={label}
//       labelPlacement="start"
//     />
//   </ListItem>
// );
export const ListItemToggle = ({
  style = {},
  label,
  labelStyle = {},
  checked = undefined,
  defaultChecked = false,
  onChange,
  className,
  disabled = false,
  icon = null,
}: {
  style?: any;
  label: string | JSX.Element;
  labelStyle?: any;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className: string;
  disabled?: boolean;
  icon?: JSX.Element | null;
}) => {
  const [isDarkMode] = useIsDarkMode();
  return (
    <ToggleStyles
      style={style}
      className={checked ? "checked" : ""}
      $isDarkMode={isDarkMode}
    >
      {icon}
      <FormControlLabel
        className={className}
        control={
          <Switch
            {...(checked === undefined ? { defaultChecked } : { checked })}
            onChange={onChange}
            disabled={disabled}
          />
        }
        label={label}
        labelPlacement="start"
        style={labelStyle}
      />
    </ToggleStyles>
  );
};
